import classNames from "classnames";
import { debounce } from "lodash";
import { useEffect, useState } from "react";
import "./index.less";

const BackToTop = () => {
  const SHOW_SCROLL_Y = 400;
  const [show, setShow] = useState(false);

  useEffect(() => {
    const listener = debounce(
      () => {
        setShow(window.scrollY >= SHOW_SCROLL_Y);
      },
      300,
      { maxWait: 600 }
    );

    window.addEventListener("scroll", listener, false);
    return () => window.removeEventListener("scroll", listener);
  }, []);

  const handleClick = () => {
    window.scroll(0, 0);
  };

  return <div className={classNames("back-to-top", { show })} onClick={handleClick}></div>;
};
export default BackToTop;
